const config = require('../../../../../config/locales_json/packs/private/validations/resend_activate.json');
const language = $('body').data("language");

$("#kt_login_resend_form #kt_login_resend_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_resend_form #user_email")

  if(!email.val()){
    const errorText = getTranslationValue(config, [language, "user_emai"],"Debes ingresar el email con el cual te registraste.");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Enviando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_resend_form").submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}